/**
 * Universal Colors
 */

const pastimeYellow = '#EFB21F';

export interface Color {
  [color: string]: string;
}

const COLORS: Color = {
  mlbGrey1: '#f3f3f3',
  mlbGrey2: '#dddddd',
  mlbGrey3: '#aaaaaa',
  mlbGrey4: '#888888',
  mlbGrey5: '#666666',
  mlbGrey6: '#444444',
  mlbGrey7: '#222222',
  mlbGrey8: '#121212',

  // Dropdown border & fill Colors
  lightSlateGray: '#7F8994',
  slateGray: '#6A7480',
  transparentGrayLightMode: '#070A0D0D',
  transparentGrayDarkMode: '#FFFFFF0D',

  mlbBlack: '#000000',

  mlbWhite: '#ffffff',
  mlbWhiteShadow: 'rgba(255, 255, 255, 0.3)',

  blueRibbon: '#006EF5',
  linkBlueText: '#0048C7', // x-homepage link text color
  linkBlue: '#0048C7', // complies with accessibility standards
  linkBlueOnDark: '#5298FF',
  linkBlueOnDarkShadow: 'rgba(72, 157, 255, 0.3)',
  starsBlue: '#0048AB',
  libertyBlue: '#041E42',
  wrapBlue: '#0457A9',

  stripesRed: '#BC0022',
  mlbTvOrange: '#FD7E17',
  liveYellow: '#FFA801',
  ticketGreen: '#00AF61',
  favoriteYellow: pastimeYellow,

  outsYellow: pastimeYellow,
  outOrange: '#ff9b3d',
  outGrey: '#c6c6c6',

  transparent: 'transparent',

  // Universal Hovering Colors
  // light
  linkBlueHover: '#0462CC',
  ticketGreenHover: '#008C4E',
  mlbTvOrangeHover: '#CA6512',
  // dark
  linkBlueOnDarkHover: '#3A7ECC',

  // Input validation Colors
  inputInvalid: '#BC0022',
  inputInvalidOnDark: '#FF322C',

  // Tab focused outline color
  tabFocusColor: '#4D90FE',

  // Skeleton
  skeletonLightMain: '#F0F0F0',
  skeletonLightHighlight: '#D0D0D0',
  skeletonDarkHighlight: '#2a2a2a',

  //Tag dark blue background color
  taglinkBlueOnDark: '#336699',

  //on focus outline color
  focusedBlue: '#3DB3F8',

  liveBlue: '#0559FF',

  focusBlue: '#015FCC',
};

export default COLORS;
